<template>
  <BaseTableWrapper v-if="$route.name === 'DocumentTemplateList'">
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'DocumentTemplateCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.documenttemplates.list.noDocumentTemplates') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.documenttemplates.list.title') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.title }}</td>
            <td>
              <div class="btn-group">
                <button type="button" class="btn btn-sm btn-link fa fa-edit fa-lg" @click="editItem(item)" v-b-tooltip.hover :title="$t('buttons.edit')"></button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'List',

  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },

  data () {
    return {
      url: 'document_templates'
      // searchParams: {
      // }
    }
  },

  props: ['item', 'userData'],

  computed: mapGetters({
    error: 'documenttemplate/list/error',
    items: 'documenttemplate/list/items',
    isLoading: 'documenttemplate/list/isLoading',
    view: 'documenttemplate/list/view'
  }),

  beforeCreate () {
    checkPagePermission('configuration', 'DocumentTemplateList')
  },

  created () {
    this.getPage(addParamsToQuery(this.url, this.searchParams))
  },

  methods: {
    ...mapActions({
      getPage: 'documenttemplate/list/getItems'
    }),
    editItem (item) {
      this.$Swal({
        title: this.$t('views.documenttemplates.notifications.edit.title'),
        text: this.$t('views.documenttemplates.notifications.edit.text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.$router.push({ name: 'DocumentTemplateUpdate', params: { id: item['@id'] } })
      })
    }
  }
}
</script>

<style scoped>

</style>
